export default {
    meta: {
        title: '招商管理',
    },
};
